import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import domPurify from 'dompurify'

function stripHtml (html) {
  const template = document.createElement('template')
  template.innerHTML = html
    .replace(/<\s*br\s*\/?>/gi, ' ')
    // .replace(/\n/g, ' ')
    // .replace(/&nbsp;/g, ' ')
  return template.content.textContent || ''
}

function MarkupPreview ({ value, type, unescape, length, className, style, ...rest }) {
  const item = useMemo(() => {
    if (value !== null && typeof value === 'object') {
      return null
    }
    if (Array.isArray(value)) {
      return null
    }
    if ([null, undefined].includes(value)) {
      return null
    }

    switch (type) {
      case 'html': {
        const _html = unescape ? value.replaceAll('&lt;', '<').replaceAll('&gt;', '>') : value
        const sanitized = domPurify.sanitize(_html)
        return (stripHtml(sanitized) || '').substring(0, length)
      }
      case 'markdown':
      case 'plain':
      default:
        return (value || '').substring(0, length)
    }
  }, [value, type, unescape, length])

  if (!item) return null

  const _style = { fontWeight: '100', ...(style || {}) }
  return (
    <span className={className} style={_style}>
      {length < (value || '').length ? `${item}...` : item}
    </span>
  )
}

MarkupPreview.propTypes = {
  /** The markup content to render */
  value: PropTypes.string,

  type: PropTypes.oneOf(['html', 'plain', 'markdown']),

  length: PropTypes.number,

  unescape: PropTypes.bool,

  className: PropTypes.string,

  style: PropTypes.object
}

MarkupPreview.defaultProps = {
  unescape: true,
  length: 50
}

export default MarkupPreview
